import { ClassNameOnlyProps } from 'module/types/common';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { TooltipPlacement } from 'antd/lib/tooltip';
import { ReactNode, FC } from 'react';
import styled, { css } from 'styled-components';
import { Action } from './components';
import { FontAwesomeIcon } from '../../atoms/icon/icon';
import { OutsideClickHandler } from '../../atoms/outside-click-handler';
import { Popover as PopoverAtom } from '../../atoms/popover';

interface Props extends ClassNameOnlyProps {
  title: ReactNode;
  allowed: (target: HTMLElement) => boolean;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  hideChevron?: boolean;
  placement?: TooltipPlacement | undefined;
  disabled?: boolean;
  type?: string;
  loading?: boolean;
}

const Popover = styled(PopoverAtom)`
  display: flex;
  flex-direction: column;

  .ant-popover-content {
    margin-right: calc(-1 * var(--spacing-03));
  }
`;

type LeftProps = {
  type?: string;
};

const Left = styled.div<LeftProps>`
  flex: 1;
  display: inline-flex;
  color: ${({ type }) =>
    type === 'danger' ? 'var(--error-color)' : '#161616'};
`;

const ControlledPopoverActionComponent: FC<React.PropsWithChildren<Props>> = ({
  title,
  allowed,
  children,
  visible,
  setVisible,
  className,
  hideChevron,
  placement,
  disabled,
  loading,
  type = '',
}) => (
  <Popover
    className={className}
    trigger={[]}
    open={visible}
    placement={placement || 'left'}
    destroyTooltipOnHide={{ keepParent: false }}
    content={children}
  >
    <OutsideClickHandler
      allowed={allowed}
      onOutsideClick={() => setVisible(false)}
    >
      <Action
        disabled={disabled}
        onClick={() => setVisible(!visible)}
        textType={type}
        loading={loading}
      >
        <Left type={type}>{title}</Left>
        {!hideChevron && <FontAwesomeIcon icon={faChevronRight} />}
      </Action>
    </OutsideClickHandler>
  </Popover>
);

export const ControlledPopoverAction = styled(ControlledPopoverActionComponent)`
  ${Action} {
    ${({ visible }) =>
      visible &&
      css`
        background: var(--action-hover-background);
      `};
  }
`;
